module.exports = __webpack_public_path__ + "img/digital_5.0834722f.jpg";